"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterNav = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var FooterNav = exports.FooterNav = _styledComponents["default"].div.withConfig({
  displayName: "FooterNav",
  componentId: "sc-k2rrgd-0"
})(["@media (max-width:", "){left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);}@media (min-width:", "){display:none;}"], _encoreFoundation.screenXsMax, _encoreFoundation.screenSmMin);